// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { IconUserCheck, IconBasket, IconMessages,
     IconLayoutKanban, IconMail, IconCalendar, 
     IconNfc, IconUserCircle ,
     IconHexagonNumber0
} from "@tabler/icons-react"

// constant
const icons = {
    IconUserCheck,
    IconBasket,
    IconMessages,
    IconLayoutKanban,
    IconMail,
    IconCalendar,
    IconNfc
};

// ==============================|| APPLICATION MENU ITEMS ||============================== //

const candidatures = {
    id: 'resouces_humaines1',
    title: ["N. ", <FormattedMessage id="resouces_humaines" />],
    type: 'group',
    icon: <IconHexagonNumber0 />, // Use a valid icon component here
   /*  children: [

        {
            id: 'collapse1',
            title: <FormattedMessage id="collapse" />,
            type: 'collapse',
            icon: icons.IconUserCheck, */
            children: [
    
                {
                    id: 'categorias_travalleurs1',
                    title: ["1. ",<FormattedMessage id="categorias_travalleurs" />],
                    type: 'item',
                    url: '/professor/CategoriasTravailleurs'
                },
                {
                    id: 'liste_de_categorie2',
                    title: ["2. ", <FormattedMessage id="liste_de_categorie" />],
                    type: 'item',
                    url: '#'
                },

                {
                    id: 'departementsTr',
                    title: ["1. ",<FormattedMessage id="departement_travailleurs" />],
                    type: 'item',
                    url: '/resourcesHumaine/DepartementEmployes'
                },

                {
                    id: 'functionsTra',
                    title: ["1. ",<FormattedMessage id="functions_travaileurs" />],
                    type: 'item',
                    url: '/resourcesHumaine/FunctionsEmployes'
                },

                {
                    id: 'enegister_travailleur1',
                    title: ["3. ", <FormattedMessage id="enegister_travailleur" />],
                    type: 'item',
                    url: '/resourcesHumaine/NewTravailleur'
                },

                        {
                            id: 'liste_des_travailleurs1',
                            title: ["4. ",<FormattedMessage id="liste_des_travailleurs" />],
                            type: 'item',
                            url: '/resourcesHumaine/ListeGeneralTravailleurAdmin'
                            // '/user/social-profile/posts'
                        },

                        {
                            id: 'gestion_retenues',
                            title: ["5. ",<FormattedMessage id="gestion_de_returnes" />],
                            type: 'item',
                            url: '/resourcesHumaine/RetenuesCategory'
                        },

                        {
                            id: 'retenue_individuelle_enregistrer1',
                            title: ["6. ",<FormattedMessage id="retenue_individuelle_enregistrer" />],
                            type: 'item',
                            url: '/resourcesHumaine/RetenueIndividuelle'
                        },

                        {
                            id: 'gestion_de_primes1',
                            title: ["7. ",<FormattedMessage id="gestion_de_primes" />],
                            type: 'item',
                            url: '/resourcesHumaine/PrimeCategory'
                        },

                        
                        {
                            id: 'prime_individuelle_enregistrer1',
                            title: ["8. ",<FormattedMessage id="prime_individuelle_enregistrer" />],
                            type: 'item',
                            url: '/resourcesHumaine/PrimeIndividuelle'
                        },
                    
                       
                        {
                            id: 'gestion_conges1',
                            title: ["9. ", <FormattedMessage id="gestion_conges" />],
                            type: 'item',
                            url: '#'
                        },

                        {
                            id: 'presences_travailleurs1',
                            title: ["10. ",<FormattedMessage id="presences_travailleurs" />],
                            type: 'item',
                            url: '#'
                        },

                        {
                            id: 'horaire_travailleur1',
                            title: ["11. ", <FormattedMessage id="horaire_travailleur" />],
                            type: 'item',
                            url: '#'
                        },

    ]
// },

//]
};

export default candidatures;
